import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  serviceOrderId: null,
  engineeringReportId: null,
};

const orderSlice = createSlice({
  name: "serviceOrder",
  initialState,
  reducers: {
    setServiceOrderId: (state, action) => {
      state.serviceOrderId = action.payload;
    },
    resetServiceOrderId: (state) => {
      state.serviceOrderId = null;
    },

    setEngineeringReportId: (state, action) => {
      state.engineeringReportId = action.payload;
    },
    resetEngineeringReportId: (state) => {
      state.engineeringReportId = null;
    },

    resetOrderState: (state) => {
      state.serviceOrderId = null;
      state.engineeringReportId = null;
    },
  },
});

export const {
  setServiceOrderId,
  resetServiceOrderId,
  setEngineeringReportId,
  resetEngineeringReportId,
  resetOrderState,
} = orderSlice.actions;

export default orderSlice.reducer;
